import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'

export const PageTemplate = styled.div`
    height: 100%;
    display: grid;
    grid-template-rows: min-content auto;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        grid-template-rows: min-content min-content;
    }
`
export const LoadingContainer = styled.div`
    display: flex;
    height: 100dvh;
    justify-content: center;
    align-items: center;
`
